export enum ViewingTypeCode {
  AUTO_FACEBOOK_FOLLOW = 'auto-facebook-follow-',
  AUTO_FACEBOOK_LIKE = 'auto-facebook-like-',
  AUTO_FACEBOOK_PAGELIKE = 'auto-facebook-pagelike-',

  AUTO_INSTAGRAM_COMMENT = 'auto-instagram-comment-',
  AUTO_INSTAGRAM_FOLLOW = 'auto-instagram-follow-',
  AUTO_INSTAGRAM_LIKE = 'auto-instagram-like-',

  AUTO_NBLOG_COMMENT = 'auto-nblog-comment-',
  AUTO_NBLOG_FOLLOW = 'auto-nblog-follow-',
  AUTO_NBLOG_LIKE = 'auto-nblog-like-',
  AUTO_NBLOG_SCRAP = 'auto-nblog-scrap-',

  AUTO_NKIN_COMMENT = 'auto-nkin-comment-',
  AUTO_NKIN_LIKE = 'auto-nkin-like-',

  AUTO_NPLACE_BOOKMARK = 'auto-nplace-bookmark-',
  AUTO_NPLACE_NOTIFICATION = 'auto-nplace-notification-',

  AUTO_THREADS_FOLLOW = 'auto-threads-follow-',
  AUTO_THREADS_LIKE = 'auto-threads-like-',

  AUTO_YOUTUBE_LIKE = 'auto-youtube-like-',
  AUTO_YOUTUBE_SUBSCRIBE = 'auto-youtube-subscribe-',

  FACEBOOK_COMMENT = 'click-facebook-comment-',
  FACEBOOK_FOLLOW = 'click-facebook-follow-',
  FACEBOOK_LIKE = 'click-facebook-like-',
  FACEBOOK_PAGELIKE = 'click-facebook-pagelike-',

  INSTAGRAM_COMMENT = 'click-instagram-comment-',
  INSTAGRAM_FOLLOW = 'click-instagram-follow-',
  INSTAGRAM_LIKE = 'click-instagram-like-',

  NBLOG_BLOG = 'post-nblog-blog-',
  NBLOG_BLOG_LITE = 'post-nblog-blog-lite-',
  NBLOG_BLOG_PRO = 'post-nblog-blog-pro-',
  NBLOG_BLOG_PREMIUM = 'post-nblog-blog-premium-',

  NBLOG_COMMENT = 'click-nblog-comment-',
  NBLOG_FOLLOW = 'click-nblog-follow-',
  NBLOG_LIKE = 'click-nblog-like-',
  NBLOG_SCRAP = 'click-nblog-scrap-',

  NKIN_COMMENT = 'click-nkin-comment-',
  NKIN_LIKE = 'click-nkin-like-',

  NPLACE_BOOKMARK = 'click-nplace-bookmark-',
  NPLACE_NOTIFICATION = 'click-nplace-notification-',

  PLUS_INSTAGRAM_LIKE = 'plus-instagram-like-',
  PLUS_INSTAGRAM_POST = 'plus-instagram-post-',

  THREADS_COMMENT = 'click-threads-comment-',
  THREADS_FOLLOW = 'click-threads-follow-',
  THREADS_LIKE = 'click-threads-like-',

  YOUTUBE_COMMENT = 'click-youtube-comment-',
  YOUTUBE_LIKE = 'click-youtube-like-',
  YOUTUBE_SUBSCRIBE = 'click-youtube-subscribe-',

  MACRO_INSTAGRAM_LIKE = 'macro_click-instagram-like-',
  MACRO_INSTAGRAM_FOLLOW = 'macro_click-instagram-follow-',
  MACRO_INSTAGRAM_COMMENT = 'macro_click-instagram-comment-',

  MACRO_FACEBOOK_COMMENT = 'macro_click-facebook-comment-',
  MACRO_FACEBOOK_FOLLOW = 'macro_click-facebook-follow-',
  MACRO_FACEBOOK_LIKE = 'macro_click-facebook-like-',
  MACRO_FACEBOOK_PAGELIKE = 'macro_click-facebook-pagelike-',

  MACRO_NBLOG_COMMENT = 'macro_click-nblog-comment-',
  MACRO_NBLOG_FOLLOW = 'macro_click-nblog-follow-',
  MACRO_NBLOG_LIKE = 'macro_click-nblog-like-',
  MACRO_NBLOG_SCRAP = 'macro_click-nblog-scrap-',

  MACRO_NKIN_COMMENT = 'macro_click-nkin-comment-',
  MACRO_NKIN_LIKE = 'macro_click-nkin-like-',

  MACRO_NPLACE_BOOKMARK = 'macro_click-nplace-bookmark-',
  MACRO_NPLACE_NOTIFICATION = 'macro_click-nplace-notification-',

  MACRO_THREADS_COMMENT = 'macro_click-threads-comment-',
  MACRO_THREADS_FOLLOW = 'macro_click-threads-follow-',
  MACRO_THREADS_LIKE = 'macro_click-threads-like-',

  MACRO_YOUTUBE_COMMENT = 'macro_click-youtube-comment-',
  MACRO_YOUTUBE_LIKE = 'macro_click-youtube-like-',
  MACRO_YOUTUBE_SUBSCRIBE = 'macro_click-youtube-subscribe-',
}
